import React from "react";

import CommunitySection from "./CommunitySection";

const columns = [
  {
    title: "Source",
    dataIndex: "source",
    key: "source"
    // width: 32
  },
  {
    title: "Variant allele",
    dataIndex: "variantAllele",
    key: "variantAllele"
    // width: 32
  },
  {
    title: "Homozygotes",
    dataIndex: "homozygotes",
    key: "homozygotes"
    // width: 32
  },
  {
    title: "Frequency",
    dataIndex: "frequency",
    key: "frequency"
    // width: 32
  },
  {
    title: "Allele frequency log",
    dataIndex: "alleleFrequencyLog",
    key: "alleleFrequencyLog"
    // width: 32
  }
];

const data = [
  {
    key: 1,
    title: "Ancestry",
    variantAllele: 1180,
    homozygotes: 13,
    frequency: 0.17,
    alleleFrequencyLog: 55,
    maxRecessive: 0.78,
    splitting: [
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      }
    ]
  },
  {
    key: 2,
    title: "gnomAD",
    variantAllele: 1180,
    homozygotes: 13,
    frequency: 0.17,
    alleleFrequencyLog: 55,
    maxRecessive: 0.78,
    splitting: [
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      }
    ]
  },
  {
    key: 3,
    title: "ESP",
    variantAllele: 1180,
    homozygotes: 13,
    frequency: 0.17,
    alleleFrequencyLog: 55,
    maxRecessive: 0.78,
    splitting: [
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      },
      {
        title: "Latino",
        variantAllele: 34,
        homozygotes: 1,
        frequency: "0.08%",
        alleleFrequencyLog: 45
      }
    ]
  }
];

class Community extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <div className="community">
        <div className="community__head">
          <div className="community__title">Allele Frequency Community</div>
          <a href="/#/" className="community__link">
            <img className="community__icon" src="/img/link.svg" alt="" />
          </a>
        </div>
        <div className="community__body">
          <div className="community__table">
            <div className="community__section">
              <div className="community__row">
                {columns.map((x, i) => (
                  <div className="community__cell" key={i}>
                    <div className="label">{x.title}</div>
                  </div>
                ))}
              </div>
            </div>
            {data.map((x, i) => <CommunitySection item={x} key={i} />)}
          </div>
        </div>
      </div>
    );
  }
}

export default Community;
